export default __webpack_public_path__ + "static/media/IMG_2892.cc032902.JPG";